import { ClickAction } from './report'

/**
 * 产品分类
 */
const PRODUCT_CATEGORY = {
  WATCH: {
    value: `WATCH`,
    label: `腕表`,
    cover: `WATCH`,
    actionNumber: ClickAction.NEWWORKS_OF_WATCHES,
    actionNumberOfAll: ClickAction.ALLWORKS_OF_WATCHES
  },
  RING: {
    value: `RING`,
    label: `戒指`,
    cover: `RING`,
    actionNumber: ClickAction.NEWWORKS_OF_RINGS,
    actionNumberOfAll: ClickAction.ALLWORKS_OF_RINGS
  },
  BRACELET: {
    value: `BRACELET`,
    // label: `手镯及手链`,
    label: `手镯`,
    cover: `BRACELET`,
    actionNumber: ClickAction.NEWWORKS_OF_BRACELETS,
    actionNumberOfAll: ClickAction.ALLWORKS_OF_BRACELETS
  },
  EARRING: {
    value: `EARRING`,
    label: `耳环`,
    cover: `EARRING`,
    actionNumber: ClickAction.NEWWORKS_OF_EARRINGS,
    actionNumberOfAll: ClickAction.ALLWORKS_OF_EARRINGS
  }
}

export type ProductCategoryValue = keyof typeof PRODUCT_CATEGORY
export type ProductCategoryConfig = typeof PRODUCT_CATEGORY.BRACELET & {
  kv: string
}

export enum RPODUCT_ATTRIBUTE_TYPE {
  PRODUCT_LINE,
  MATERIAL,
  CUSTOM_TAG
}

/**
 * 产品属性
 */
/**
 * 产品线
 */
const PRODUCT_LINES = [
  {
    label: `COCOCRUSH`
  },
  { label: `PREMIÈRE` },
  { label: `J12` },
  { label: `PJN5` },
  { label: `CAMÉLIA` }
] as const

/**
 * 产品材质
 */
const MATERIALS = [
  {
    label: `BEIGE_GOLD`,
    name: '米色K金',
    image: 'beige_gold_principal',
    hidden: false
  },
  {
    label: `YELLOW_GOLD`,
    name: '黄18K金',
    image: 'yellow_gold_principal',
    hidden: false
  },
  {
    label: `WHITE_GOLD`,
    name: '白18K金',
    image: 'white_gold_principal',
    hidden: false
  },
  {
    label: `WHITE_CERAMIC`,
    name: '白色陶瓷',
    image: 'white_ceramic_watches',
    hidden: false
  },
  {
    label: `BLACK_CERAMIC`,
    name: '黑色陶瓷',
    image: 'black_ceramic_watches',
    hidden: false
  },
  {
    label: `DIAMOND`,
    name: '钻石',
    image: 'diamond_principal',
    hidden: false
  },
  {
    label: `WATCH_DIAMOND`,
    name: '钻石',
    image: 'diamond_watch',
    hidden: false
  },
  {
    label: `STAINLESS_STEEL`,
    name: '精钢',
    image: 'steel_principal',
    hidden: false
  },
  {
    label: `CALF`,
    name: '黑色皮革',
    image: 'calf_principal',
    hidden: false
  },
  {
    label: `ROSE_GOLD`,
    name: '玫瑰金',
    image: 'pink-gold',
    hidden: true
  }
] as const

const HAND_TAGS = ['TEST'] as const
const FACIAL_TAGS = [] as const

export type MATERIAL = (typeof MATERIALS)[number]
type PRODUCT_LINE = (typeof PRODUCT_LINES)[number]['label']
type MATERIAL_LABEL = MATERIAL['label']
type HAND_TAG = (typeof HAND_TAGS)[number]
type FACIAL_TAG = (typeof FACIAL_TAGS)[number]

export type ATTRIBUTE_KEY =
  | PRODUCT_LINE
  | MATERIAL_LABEL
  | HAND_TAG
  | FACIAL_TAG

export type PRODUCT_LINE_ATTRIBUTE = {
  type: RPODUCT_ATTRIBUTE_TYPE.PRODUCT_LINE
  label: string
}
export type MATERIAL_ATTRIBUTE = {
  type: RPODUCT_ATTRIBUTE_TYPE.MATERIAL
  label: string
  icon: string
}

export type TAG_ATTRIBUTE = {
  type: RPODUCT_ATTRIBUTE_TYPE.CUSTOM_TAG
  label: string
  isHand: boolean
}

const PRODUCT_ATTRIBUTE = {
  ...(Object.fromEntries(
    HAND_TAGS.map(label => [
      label,
      {
        label,
        type: RPODUCT_ATTRIBUTE_TYPE.CUSTOM_TAG,
        isHand: true
      }
    ])
  ) as Record<HAND_TAG, TAG_ATTRIBUTE>),
  ...(Object.fromEntries(
    FACIAL_TAGS.map(label => [
      label,
      {
        label,
        type: RPODUCT_ATTRIBUTE_TYPE.CUSTOM_TAG,
        isHand: false
      }
    ])
  ) as Record<FACIAL_TAG, TAG_ATTRIBUTE>),
  ...(Object.fromEntries(
    PRODUCT_LINES.map(m => [
      m.label,
      {
        type: RPODUCT_ATTRIBUTE_TYPE.PRODUCT_LINE,
        label: m.label
      }
    ])
  ) as Record<PRODUCT_LINE, PRODUCT_LINE_ATTRIBUTE>),
  ...(Object.fromEntries(
    MATERIALS.map(m => [
      m.label,
      {
        type: RPODUCT_ATTRIBUTE_TYPE.MATERIAL,
        label: m.label,
        icon: m.image
      }
    ])
  ) as Record<MATERIAL_LABEL, MATERIAL_ATTRIBUTE>)
}

export { PRODUCT_CATEGORY, MATERIALS, PRODUCT_ATTRIBUTE }
